/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

export class Url {
  public static parse(url: string): any {
    const pattern = new RegExp(
      [
        '^(https?:)//', // protocol
        '(([^:/?#]*)(?::([0-9]+))?)', // host (hostname and port)
        '(/?[^?#]*)', // pathname
        '(\\?[^#]*|)', // search
        '(#.*|)$', // hash
      ].join(''),
    );

    const match = url.match(pattern);

    return (
      match && {
        hash: match[7] !== null ? match[7].substr(1) : match[7],
        host: match[2],
        hostname: match[3],
        pathname: match[5],
        port: match[4],
        protocol: match[1] !== null ? match[1].slice(0, -1) : match[1],
        search: match[6] !== null ? match[6].substr(1) : match[6],
      }
    );
  }
}
